/**
 * Custom Filters - Style Collection
 * Template-specific configuration for style/trend collections
 *
 * Requires: custom-filters-core.js to be loaded first
 */

document.addEventListener('DOMContentLoaded', function() {
  // Get collection handle (slug) from URL
  let collectionHandle = window.location.pathname.split('/collections/')[1]?.split('/')[0] || 'all';

  // Trend name mapping for handles that don't match the API's trend value.
  // Shopify handleizes the collection title (e.g. "Farmhouse & Rustic" -> "farmhouse-rustic"),
  // dropping the spaces/ampersand the API expects. Map the URL handle to the real trend name here.
  // The API is case-insensitive and core.js URL-encodes the value, so spaces and "&" pass through fine.
  const TREND_NAME_MAPPING = {
    'farmhouse-rustic': 'Farmhouse & Rustic',
    'modern-contemporary' : 'Modern & Contemporary',
    'classic-traditional' : 'Classic & Traditional',
  };

  // Map the URL handle to the actual trend name for API calls
  const apiParamValue = TREND_NAME_MAPPING[collectionHandle.toLowerCase()] || collectionHandle;

  // Initialize with style-specific config.
  // The trend name is passed to the filter API via the `trend` param.
  window.CustomFilters.init({
    type: 'category',
    collectionHandle: collectionHandle,
    apiParamName: 'trend',
    apiParamValue: apiParamValue,
    excludedFilters: ['categories', 'locations', 'trends', 'motorTypes'],
    extraApiParams: {}
  });
});
